import { render, staticRenderFns } from "./MySuperior.vue?vue&type=template&id=7d143d03&scoped=true&"
import script from "./MySuperior.vue?vue&type=script&lang=js&"
export * from "./MySuperior.vue?vue&type=script&lang=js&"
import style0 from "./MySuperior.vue?vue&type=style&index=0&id=7d143d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d143d03",
  null
  
)

export default component.exports